var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#999","fillRule":"evenodd","d":"M5.497 3.207L8.967.046l1.532 1.393-5.002 4.576L.498 1.439 2.028.046l3.469 3.161z"}));
}

Arrow.defaultProps = {"width":"11","height":"6"};

module.exports = Arrow;

Arrow.default = Arrow;
